export const API_URL = process.env.REACT_APP_API_URL ?? "";
export const CLIENT_INSTANCE = process.env.REACT_APP_CLIENT_INSTANCE ?? "";
export const REACT_APP_LOGO = process.env.REACT_APP_LOGO ?? "";
export const REACT_TITLE = process.env.REACT_APP_TITLE ?? "";
export const FB_PIXEL = process.env.REACT_APP_FB_PIXEL ?? "";
